import gql from 'graphql-tag';

const createDefaultCoverageOptOutMutation = gql`
  mutation CreateDefaultCoverageOptOut(
    $input: CreateDefaultCoverageOptOutInput!
  ) {
    createDefaultCoverageOptOut(input: $input) {
      success
      errors
      defaultCoverageOptOutEntry {
        id
        buyerNumber
        sellerNumber
        auctionAccessNumber
        productId
        productCode
        startDate
        endDate
        notes
        status
        version
        createdBy
        createdAt
      }
    }
  }
`;

export default createDefaultCoverageOptOutMutation;
